import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';

const getVersioningOptions: QueryFunction<
  string[],
  ['/document/versioning-options']
> = async () => {
  if (isMockServices()) return await mock(_mockVersioningOptions);

  return _mockVersioningOptions;
};

export default getVersioningOptions;

const _mockVersioningOptions = [
  'Initial',
  'Intermediate',
  'Final',
  'Duplicate',
  'Manual',
  'Unversioned',
];
